import moment from 'moment';

export function formatDateTime(date?: string): string {
  if (!date) {
    return '';
  }
  const parsedDate = moment(date);
  return parsedDate.format(parsedDate.isSame(new Date(), 'year') ? 'DD MMMM HH:mm' : 'DD MMMM YYYY HH:mm');
}
